const Header = () => (
  <header 
    style={{ 
      paddingTop: "15%",
      paddingBottom: "5%", 
      textAlign: "center", 
      backgroundColor: "#111" 
    }}
  >
    <h1 
      style={{ 
        fontSize: "3rem", 
        fontWeight: "bold", 
        marginBottom: "1.5rem",
        color: "white" 
      }}
    >
      All Resources
    </h1>
    <p
      style={{
        color: "#9CA3AF",
        maxWidth: "42rem",
        margin: "0 auto",
        padding: "0 1rem"
      }}
    >
      Explore our extensive collection of resources to fuel your business growth and success
    </p>
  </header>
);

export default Header;
      